export type AssetDomain =
  | "blog"
  | "case-studies"
  | "client-logos"
  | "graphics"
  | "headers"
  | "labs"
  | "location"
  | "location-small"
  | "rapid"
  | "team"
  | "work";

export function assetPath(domain: AssetDomain, filename: string): string {
  return `/assets/${domain}/${filename}`;
}

export type VideoDomain = "backgrounds" | "work";

export function videoPath(filename: string, domain?: VideoDomain): string {
  if (!domain) return `/video/backgrounds/${filename}`;
  return `/video/${domain}/${filename}`;
}

export function faviconPath(filename: string): string {
  return `/favicon/${filename}`;
}

export const MEDIA = {
  /** Prefer WebP; keep PNG for `<img>` fallbacks where needed. */
  cardTexture: "/assets/card-texture.webp",
  cardTexturePng: "/assets/card-texture.png",
  /** 720p H.264 re-encode (~0.9MB vs ~3.6MB source); original kept in repo for art swaps. */
  heroCloudsVideo: "/video/backgrounds/hero-clouds-ascii-720p.mp4",
  heroCloudsPoster: "/video/backgrounds/hero-clouds-poster.webp",
} as const;
